import React from "react";

import type { Contact } from "../types";

const ContactList = React.lazy(() =>
  import("./ContactList").then((m) => ({ default: m.ContactList })),
);
const ContactShow = React.lazy(() =>
  import("./ContactShow").then((m) => ({ default: m.ContactShow })),
);
const ContactEdit = React.lazy(() =>
  import("./ContactEdit").then((m) => ({ default: m.ContactEdit })),
);
const ContactCreate = React.lazy(() =>
  import("./ContactCreate").then((m) => ({ default: m.ContactCreate })),
);

export default {
  list: ContactList,
  show: ContactShow,
  edit: ContactEdit,
  create: ContactCreate,
  // Not lazy: used to label a contact wherever one is referenced, including
  // from other resources' screens.
  recordRepresentation: (record: Contact) =>
    record?.first_name + " " + record?.last_name,
};
